import {
	SET_ADDRESS_DATA,
	UPDETE_ADDRESS,
	DELETE_ADDRESS,
	
	RECORD_ADDRESS,
	ADD_CART,
	REDUCE_CART,
	EDIT_CART,
	SELECT_CART,
	SET_CART_TOTAL,
	INIT_BUYCART,
	INIT_REPLACE_BUYCART,
	CLEAR_CART,
	SET_NOTICES,
	SET_WAREHOUSE,
	SET_PRODUCT,
	SET_PRODUCTSTOCK,
	RECORD_SHOPDETAIL,
	RECORDWX_USERINFO,
	GET_USERINFO,
	CONFIRM_REMARK,
	CONFIRM_INVOICE,
	CHOOSE_SEARCH_ADDRESS,
	SAVE_GEOHASH,
	CONFIRM_ADDRESS,
	CHOOSE_ADDRESS,
	NEED_VALIDATION,
	SAVE_CART_ID_SIG,
	SAVE_ORDER_PARAM,
	CHANGE_ORDER_PARAM,
	ORDER_SUCCESS,
	SAVE_SHOPID,
	SAVE_ORDER,
	OUT_LOGIN,
	RETSET_NAME,
	SAVE_AVANDER,
	SAVE_ADDRESS,
	SAVE_ADDDETAIL,
	SAVE_QUESTION,
	ADD_ADDRESS,
	BUY_CART,
	EDIT_USERINFO,
	SET_CONTRACT,
	SAVE_EXTEND,
	SAVE_LRPR,
	SAVE_PAYRECORD,
	SET_ORDERNN,
	PAY_STATE,
	EDIT_USERINFO_IDCAR,
	EDIT_USERINFO_QRCODE,
	SET_PROMTE,
	SET_FORCUSTOMER,
	CLEAR_DATA,
	SET_NEWPROMOCODE,
	SET_NEWPROMOCODEALL,
	REDUCE_NEWPROMOCODE,
	INIT_NEWPROMOCODE,
	SET_CHARITABLE,
	SET_DOWNPDF,
	REDUCEALL_CART,
	SET_ORDERTYPE,
	SET_CART_TOTALRPT,
	EDIT_CART1,
	SET_ORDERSTATUS,
	SET_ORIGINA,
	REDUCEALL_ORDERINFO,
	SET_BIRTHDAYLIMT,
	SET_PRODUCTLIMT,
	SET_PAYLOAD,
	REDUCE_PAYLOAD,
	REDUCEALL_LRP,
	SET_SELECTMERGE,
	SET_CARTCHECK,
	SET_BALANCERECORD,
	LOAD_CARTCHECK,
	REDUCEALL_SELCART,
	SET_CARTCHECKALL,
	TRIGGER_MERGE,
	SET_PTBALANCE,
	SET_COMBINEPROMOTEPRODUCT,
	SET_PRODUCTMENUTREE,
} from './mutation-types.js'


//import {
//	setStore,
////	getStore,
////	removeStore
//} from '../../config/mUtils';

export default {

	[RECORD_SHOPDETAIL](state, detail) {
		state.shopDetail = detail;
	},
	// 记录用户信息
	[RECORDWX_USERINFO](state, info) {	
		state.userInfo = info;
	},
	// 加入购物车
	[ADD_CART](state, {
		category_id,
		item_id,
		product_id,
		name,
		price,
		rt_price,
		pc_price,
		pv,
		pt,
		specs,
		packing_fee,
		sku_id,
		sku,
		stock,
		is_promotion,
		is_new,
		product_number,
		promo_code,
		is_lrpt_product,
		is_hot,
		product_flag,
		remark
	}) {
		var num=product_number?product_number:1;
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || []);

		
		
		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 					
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
    		
		
		var citem=list.filter(u=>u.sku==sku&&u.num>0)[0];

		if (citem) {
			citem.num+=num;
			citem.amount= price*citem.num;
			citem.price=price;
		} else 
		{
			citem = {
					"num" : num,
					"id" : product_id,
					'category_id':category_id,
					"name" : name,
					"rt_price":rt_price,
					'pc_price':pc_price,
					"price" : price,
					"pv":pv,
					"pt":pt,
					"specs" : specs,
					"packing_fee" : packing_fee,
					"sku_id" : sku_id,
					"sku" : sku,
					"stock" : stock,
					"point":0,		//点数兑换金额
					"amount":num*price,		//现金支付金额
					//"ar_value":0	,	//AR支付金额		
					"selected":false,
					'is_promotion':is_promotion,
					'is_new':is_new,
					'promo_code':promo_code?promo_code:null,
					'is_lrpt_product':is_lrpt_product,
					'is_hot':is_hot,
					'product_flag':product_flag,
					'remark':remark?remark:null
			};
			list.push(citem)
			state.cartCheck[sku]=true;
		}

		list.forEach((item)=>{
			if(item.num>0){
				let ppt = item.pt > 0 ? item.point / item.pt : 0;
				val.num += item.num;							//购买产品总数（包括兑换的数量）
				val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
				val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
				val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      		
				val.total_change_point += item.point;		//订单兑换PT总和                		  		
				val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
			}
		})
	
		state.cartInfo={};
		state.cartInfo = cart;
	},
	[REDUCEALL_LRP](state,desclist){
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || []);

		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value

		list=list.filter(u=>u.sku!=desclist.sku)
		val.detail=list;

		list.forEach((item=>{
			if(item.num>0){
				let ppt = item.pt > 0 ? item.point / item.pt : 0;
				val.num += item.num;							//购买产品总数（包括兑换的数量）
				val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
				val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
				val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      		
				val.total_change_point += item.point;		//订单兑换PT总和                		  		
				val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
			}				
		}))

		// if(val.total_change_point > val.total_pv * 2){
		// 	list.forEach((item=>{
		// 		if(item.num>0){
		// 			let ppt = item.pt > 0 ? item.point / item.pt : 0;
		// 			item.amount += (ppt) * item.price;
		// 			item.point = 0;
		// 		}
			
		// 	}))
			
		// 	val.num = 0;								//购买产品总数（包括兑换的数量）
		// 	val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		// 	val.total_pv = 0;         					//总的产品的point value      		
		// 	val.total_change_point =  0;				//订单兑换PT总和
		// 	val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		// 	val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 	
			
		// 	list.forEach((item=>{
		// 		if(item.num>0){
		// 		let ppt = item.pt > 0 ? item.point / item.pt : 0;
		// 		val.num += item.num;							//购买产品总数（包括兑换的数量）
		// 		val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
		// 		val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
		// 		val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
		// 		val.total_change_point += item.point;		//订单兑换PT总和                		  		
		// 		val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
		// 		}
		// 	}))

		// }
		
		state.cartInfo={};
		state.cartInfo = cart;


	},
	[EDIT_CART1](state,{sku,num,price,amount,point,canCart}){
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || []);
		let balanceRecord= state.balanceRecord||{};
		let recordList=balanceRecord.list||[];
		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
		var citem=list.filter(u=>u.sku==sku&&u.num>0)[0];
		if(citem){
			if((num)<=0&&citem.point<=0){
				list=list.filter(u=>u.sku!=sku);
				val.detail=list;
				
				recordList= recordList.filter(u=>u.sku!=sku);
				
			}
			else{
				 if(citem.point>0&&citem.num>num){
					
					// var ptNum = citem.pt > 0 ? citem.point / citem.pt : 0;
					// var yu=citem.num-num;
					// if(ptNum>=yu){
					// 	citem.point=(ptNum-yu)*citem.pt
					// }
					// else{
					// 	var cyu=yu-ptNum;
					// 	citem.num-=cyu;
					// 	citem.point=0;
					// }
					citem.num=num;
					citem.point=0;


				 }
				 else{
					citem.num=num;
				}

				if(typeof(price) != "undefined"){
					citem.price=price
				}
				if(typeof(amount) != "undefined"){
					citem.amount=amount;
				}
				else{
					citem.amount=citem.price*num;
				}
				if(typeof(point) != "undefined"){
					citem.point=point;
				}
				console.log('citem',citem)
				if(canCart){
					var recordItem=recordList.filter(u=>u.sku==citem.sku);
					if(recordItem[0]){
						recordItem[0].point=citem.point;
						console.log('citem',recordItem)
					}
					else{
						recordList.push(citem)
					}
				
					console.log('state.balanceRecord',state.balanceRecord)
				}
			}
			var cartCheck=state.cartCheck;
			val.detail = list.filter((item=>{
				if(item.num>0){
					if(cartCheck[item.sku]){
						let ppt = item.pt > 0 ? item.point / item.pt : 0;
						val.num += item.num;							//购买产品总数（包括兑换的数量）
						val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
						val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
						val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      		
						val.total_change_point += item.point;		//订单兑换PT总和                		  		
						val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
					}
					return true
				}
				return false
			}))

			// if(val.total_change_point > val.total_pv * 2){
				
			// 	list.forEach((item=>{
			// 		if(item.num>0){
			// 			let ppt = item.pt > 0 ? item.point / item.pt : 0;
			// 			item.amount += (ppt) * item.price;
			// 			item.point = 0;
			// 		}
				
			// 	}))
				
			// 	val.num = 0;								//购买产品总数（包括兑换的数量）
			// 	val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
			// 	val.total_pv = 0;         					//总的产品的point value      		
			// 	val.total_change_point =  0;				//订单兑换PT总和
			// 	val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
			// 	val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 	
				
			// 	list.forEach((item=>{
			// 		if(item.num>0){
			// 		let ppt = item.pt > 0 ? item.point / item.pt : 0;
			// 		val.num += item.num;							//购买产品总数（包括兑换的数量）
			// 		val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
			// 		val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
			// 		val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
			// 		val.total_change_point += item.point;		//订单兑换PT总和                		  		
			// 		val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
			// 		}
			// 	}))

			// }
		
			console.log('cart,---cart',cart,val.total_price)
			state.cartInfo={};
			state.cartInfo = cart;
			balanceRecord.list=recordList
			state.balanceRecord=balanceRecord;
			console.log('state.cartInfo',state.cartInfo)
			console.log('state.balanceRecord',state.balanceRecord)
		}
	},
	// 修改购物车
	[EDIT_CART](state, {
		category_id,
		item_id,
		product_id,
		name,
		price,
		pv,
		pt,	//单个产品的PT
		specs,
		packing_fee,
		sku_id,
		sku,
		//selected,
		stock,
		num,
		amount,	//现金支付金额
		point	//点数兑换金额	
		
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || {});
		let category = list[category_id] = (list[category_id] || {});
		let item = category[item_id] = (category[item_id] || {});
		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = item.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
		
		/*if (item[product_id]) {
			item[product_id]['num'] : num;
		} else {*/
			item[product_id] = {
					"num" : num,		//point支付和 amount支付总计个数
					"id" : product_id,
					'category_id':category_id,
					"name" : name,
					"price" : price,
					"pv":pv,
					"pt":pt,
					"specs" : specs,
					"packing_fee" : packing_fee,
					"sku_id" : sku_id,
					"sku" : sku,
					"selected" : item["selected"] == undefined ? false : item["selected"],
					"stock" : stock,
					"point":point,			//点数兑换金额
					"amount":amount,			//现金支付金额
					"promo_code":item[product_id].promo_code,
					'is_lrpt_product':item[product_id].is_lrpt_product,
					'is_hot':item[product_id].is_hot
					//"ar_value":ar_value		//AR支付金额			
			};
		//}
		
		Object.values(list).forEach(categoryItem => {
            Object.values(categoryItem).forEach(itemValue=> {
                Object.values(itemValue).forEach(item => {
                		let ppt = item.pt > 0 ? item.point / item.pt : 0;
                		val.num += item.num;							//购买产品总数（包括兑换的数量）
                		val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
						val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
                		val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      		
                		val.total_change_point += item.point;		//订单兑换PT总和                		  		
						val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
						
                })
            })
      	});
		if(val.total_change_point > val.total_pv * 2){
			Object.values(list).forEach(categoryItem => {
				Object.values(categoryItem).forEach(itemValue=> {
					Object.values(itemValue).forEach(item => {
						let ppt = item.pt > 0 ? item.point / item.pt : 0;
						item.amount += (ppt) * item.price;
						item.point = 0;
					})
				})
			});
			val.num = 0;								//购买产品总数（包括兑换的数量）
			val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
			val.total_pv = 0;         					//总的产品的point value      		
			val.total_change_point =  0;				//订单兑换PT总和
			val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
			val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 			
			Object.values(list).forEach(categoryItem => {
				Object.values(categoryItem).forEach(itemValue=> {
					Object.values(itemValue).forEach(item => {
							let ppt = item.pt > 0 ? item.point / item.pt : 0;
							val.num += item.num;							//购买产品总数（包括兑换的数量）
							val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
							val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
							val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
							val.total_change_point += item.point;		//订单兑换PT总和                		  		
							val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
					})
				})
			});
			
		}
		//val.service_fee=val.total_change_point>0?18:0		
		state.cartInfo = {...cart};
	},
	// 选择购物车中的商品
	[SELECT_CART](state, {
		category_id,
		item_id,
		product_id,
		selected
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || {});
		let category = list[category_id] = (list[category_id] || {});
		let item = category[item_id] = (category[item_id] || {});
		/*if (item[product_id]) {
			item[product_id]['num'] : num;
		} else {*/
			let sp = item[product_id] = (item[product_id] || {});
			sp["selected"] = selected;
		//}
		state.cartInfo = {...cart};
	},
	//设置购物车的汇总信息
	[SET_CART_TOTAL](state, {
		delivery_fee,
		service_fee,
		ar_value,
		ab_value,
		result,
		check
		//,pay_fee
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 			
		let list = val.detail = (val.detail || []);
		
		console.log('cart',cart,ab_value)
		ab_value=ab_value||0

		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额	
		val.balance_value = val.balance_value || 0;		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
		

		//统计缓存里面点数
		//将AR 缓存
		var balanceRecord=state.balanceRecord||{};
		var recordList=balanceRecord.list||[]
		
		balanceRecord.ar_value=ar_value;
		
		if(recordList[0]){
			list.forEach((item)=>{
				 var recordItem=recordList.filter(u=>u.sku==item.sku)
				 if(recordItem[0]){
					 item.point=recordItem[0].point
				 }
			})
		}

		if(check){
			var checkList=state.cartCheck
			list.forEach((item)=>{

				item.price=result?item.rt_price:item.pc_price;	

				if(checkList[item.sku]){
					let ppt = item.pt > 0 ? item.point / item.pt : 0;
					item.amount=(item.num - ppt) * item.price;			
					val.num += item.num;							//购买产品总数（包括兑换的数量）
					val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
					val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
					val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	    		
					val.total_change_point += item.point;		//订单兑换PT总和                		  		
					val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
				}
			})
		}
		else{
			list.forEach((item)=>{
				item.price=result?item.rt_price:item.pc_price;	
				let ppt = item.pt > 0 ? item.point / item.pt : 0;
				item.amount=(item.num - ppt) * item.price;			
				val.num += item.num;							//购买产品总数（包括兑换的数量）
				val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
				val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
				val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	    		
				val.total_change_point += item.point;		//订单兑换PT总和                		  		
				val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
			})
		}
		
		
       
	    val.delivery_fee = delivery_fee;			//快递费
	    val.service_fee = service_fee;				//服务费
		val.ar_value = ar_value;					//AR支付金额
		val.ab_value=ab_value;
	    var tt = Math.abs(Number(val.total_product_amount + val.delivery_fee + val.service_fee-val.ab_value-val.ar_value).toFixed(2));
	    val.pay_fee = tt;							//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
			state.cartInfo=null;
		state.cartInfo = cart;
		console.log(state.cartInfo)
	},
	[REDUCEALL_CART](state,dellist){
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || {});
		dellist.forEach((del)=>{
			var category = (list[del.category_id] || {});
			var item = (category[del.item_id] || {});
			if (item && item[del.product_id]) {
				item[del.product_id].num = 0;
				
			}
		})
			state.cartInfo = {...cart};
			val.num = 0;								//购买产品总数（包括兑换的数量）
			val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
			val.total_pv = 0;         					//总的产品的point value      		
			val.total_change_point =  0;				//订单兑换PT总和
			val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
			val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 	
			
			Object.values(list).forEach(categoryItem => {
				Object.values(categoryItem).forEach(itemValue=> {
					Object.values(itemValue).forEach(item => {
						let ppt = item.pt > 0 ? item.point / item.pt : 0;
						val.num += item.num;							//购买产品总数（包括兑换的数量）
						val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
						val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
						val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
						val.total_change_point += item.point;		//订单兑换PT总和                		  		
						val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
					})
				})
			});
			if(val.total_change_point > val.total_pv * 2){
				Object.values(list).forEach(categoryItem => {
					Object.values(categoryItem).forEach(itemValue=> {
						Object.values(itemValue).forEach(item => {
							let ppt = item.pt > 0 ? item.point / item.pt : 0;
							item.amount += (ppt) * item.price;
							item.point = 0;
						})
					})
				});
				val.num = 0;								//购买产品总数（包括兑换的数量）
				val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
				val.total_pv = 0;         					//总的产品的point value      		
				val.total_change_point =  0;				//订单兑换PT总和
				val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
				val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 			
				Object.values(list).forEach(categoryItem => {
					Object.values(categoryItem).forEach(itemValue=> {
						Object.values(itemValue).forEach(item => {
								let ppt = item.pt > 0 ? item.point / item.pt : 0;
								val.num += item.num;							//购买产品总数（包括兑换的数量）
								val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
								val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
								val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
								val.total_change_point += item.point;		//订单兑换PT总和                		  		
								val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
						})
					})
				});
			}
		//console.log(state.cartInfo)
		//setStore('buyCart', state.cartInfo);
		
	},
	// 移出购物车
	[REDUCE_CART](state, {
		category_id,
		item_id,
		product_id,
		name,
		price,
		pv,
		pt,
		specs,
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 
		let list = val.detail = (val.detail || {});
		//let category = list[category_id] = (list[category_id] || {});
		let category = (list[category_id] || {});
		let item = (category[item_id] || {});
		if (item && item[product_id]) {
			
			if (item[product_id]['num'] > 0) {
				item[product_id]['num']--;
				let lpt = item[product_id]['point'] - pt;
				if(lpt <= 0){
					if(item[product_id]['amount']>0){
						item[product_id]['amount'] = item[product_id]['amount'] - price;
					}
					else{
						item[product_id]['amount'] = 0;
					}
					item[product_id]['point'] = 0;
				}
				else{
					item[product_id]['point'] = lpt;
				}
				state.cartInfo = {...cart};
			} else {				
				//商品数量为0，则清空当前商品的信息
				item[product_id] = null;
				state.cartInfo = {...cart};
			}
			val.num = 0;								//购买产品总数（包括兑换的数量）
			val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
			val.total_pv = 0;         					//总的产品的point value      		
			val.total_change_point =  0;				//订单兑换PT总和
			val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
			val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 	
			
			Object.values(list).forEach(categoryItem => {
				Object.values(categoryItem).forEach(itemValue=> {
					Object.values(itemValue).forEach(item => {
						let ppt = item.pt > 0 ? item.point / item.pt : 0;
						val.num += item.num;							//购买产品总数（包括兑换的数量）
						val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
						val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
						val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
						val.total_change_point += item.point;		//订单兑换PT总和                		  		
						val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
					})
				})
			});
			if(val.total_change_point > val.total_pv * 2){
				Object.values(list).forEach(categoryItem => {
					Object.values(categoryItem).forEach(itemValue=> {
						Object.values(itemValue).forEach(item => {
							let ppt = item.pt > 0 ? item.point / item.pt : 0;
							item.amount += (ppt) * item.price;
							item.point = 0;
						})
					})
				});
				val.num = 0;								//购买产品总数（包括兑换的数量）
				val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
				val.total_pv = 0;         					//总的产品的point value      		
				val.total_change_point =  0;				//订单兑换PT总和
				val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
				val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 			
				Object.values(list).forEach(categoryItem => {
					Object.values(categoryItem).forEach(itemValue=> {
						Object.values(itemValue).forEach(item => {
								let ppt = item.pt > 0 ? item.point / item.pt : 0;
								val.num += item.num;							//购买产品总数（包括兑换的数量）
								val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
								val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
								val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
								val.total_change_point += item.point;		//订单兑换PT总和                		  		
								val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
						})
					})
				});
			}
		}
		//console.log(state.cartInfo)
		//setStore('buyCart', state.cartInfo);
	},
	//网页初始化时从本地缓存获取购物车数据
	[INIT_REPLACE_BUYCART](state,cartInfo){
		var cart=cartInfo||{};
		var info=cart.value||{};
		var detail=info.detail||{};
		var list=[];
		
		Object.values(detail).forEach(categoryItem => {
            Object.values(categoryItem).forEach(itemValue=> {
                Object.values(itemValue).forEach(item => {
					if(item.num>0){
						item.point=0
						list.push(item)
						//list[item.sku]=item;
					}	
                })
            })
		  });
		  
		  info.detail=list;
		  state.cartInfo=null;
		  state.cartInfo = cart;
	},	
	[INIT_BUYCART](state,cartInfo) {
		var cart=cartInfo||{};
		var info=cart.value||{};
		var detail=info.detail||{};
		var list=[];
		
		Object.values(detail).forEach(categoryItem => {
            Object.values(categoryItem).forEach(itemValue=> {
                Object.values(itemValue).forEach(item => {
					if(item.num>0){
						item.point=0
						list.push(item)
						
						//list[item.sku]=item;
					}	
                })
            })
		  });
			let localinfo = (state.cartInfo||{});
			let localval = localinfo.value = (localinfo.value || {}); 
			let locallist = localval.detail = (localval.detail || []);
			var localcart= JSON.parse(JSON.stringify(locallist));
			var newlist=[];
			var listkey={};
		  if(list[0]){
			list.forEach((item,index)=>{
				var model= localcart.filter(u=>u.sku==item.sku)[0]
				if(model){
					if(!item.promo_code||item.promo_code==''){
						item.num=model.num+item.num
						item.amount=item.num * item.price;
					}
					else{
						item.promo_code=model.promo_code
						item.amount=item.num * item.price;
					}
					newlist.push(item);
					listkey[item.sku]=item.sku
				}
			})
			list.forEach((item,index)=>{
				if(!listkey[item.sku]){
					newlist.push(item);
					listkey[item.sku]=item.sku
				 }
			})
			localcart.forEach((item,index)=>{
				if(!listkey[item.sku]){
					newlist.push(item);
					listkey[item.sku]=item.sku
				 }
			})
		  }
		  else{
			newlist=localcart;
		  }
		
			cart.value=cart.value||{}
			cart.value.detail=newlist
			state.cartInfo=null;
			state.cartInfo = cart;
	},
	//清空当前商品的购物车信息
	[CLEAR_CART](state) {
		//state.cartList[shopid] = null;
		//state.cartList = {...state.cartList};
		state.choosedAddress=null;
		state.newpromoCode={};
		var cart=state.cartInfo||{};
		var info=cart.value||{};
		info=null;
		state.cartInfo = info;
		state.cartCheck={};
		state.balanceRecord={};
	},
	
	//保存通知信息
	[SET_NOTICES](state, noticeInfo) {
		state.noticeInfo = noticeInfo;
	},
	//保存仓库列表信息
	[SET_WAREHOUSE](state, warehouseInfo) {
		state.warehouseInfo = warehouseInfo;
	},
	//保存产品信息
	[SET_PRODUCT](state, productInfo) {
		state.productInfo = productInfo;
	},
	//保存产品库存
	[SET_PRODUCTSTOCK](state, productStockInfo) {
		var data={
			value:[],
			version:{}
		}
		if(productStockInfo.value){
			data.value.push({
				stock:productStockInfo.value.detail,
				warehouse:productStockInfo.value.warehouse
			})
		}
		data.version=productStockInfo.version;
		state.productStockInfo = data
	},	
	//保存商铺id
	[SAVE_SHOPID](state, shopid) {
		state.shopid = shopid;
	},
	//记录订单页面用户选择的备注, 传递给订单确认页面
	[CONFIRM_REMARK](state, {
		remarkText,
		inputText
	}) {
		state.remarkText = remarkText;
		state.inputText = inputText;
	},
	//是否开发票
	[CONFIRM_INVOICE](state, invoice) {
		state.invoice = invoice;
	},
	//选择搜索的地址
	[CHOOSE_SEARCH_ADDRESS](state, place) {
		state.searchAddress = place;
	},
	//保存geohash
	[SAVE_GEOHASH](state, geohash) {
		state.geohash = geohash;
		if (true) {}
	},
	
	//编辑送货地址
	[UPDETE_ADDRESS](state, newAddress) {
		
		state.userInfo.value.binding.address.map((data,index)=>{
		
			if(data.id==newAddress.id){
				state.userInfo.value.binding.address[index]=newAddress
			}
			else if(newAddress.is_default=='1')
			{
				state.userInfo.value.binding.address[index].is_default='0'
			}
		})	
	},
	[DELETE_ADDRESS](state,id){
		
		state.userInfo.value.binding.address = state.userInfo.value.binding.address.filter(t => t.id != id.toString());
		
	},
	//确认订单页添加新的的地址
	[CONFIRM_ADDRESS](state, newAddress) {
		
		if(newAddress.is_default=='1')
		{
			state.userInfo.value.binding.address.map((data,index)=>{
				state.userInfo.value.binding.address[index].is_default='0'
			})
		}
		state.userInfo.value.binding.address.push(newAddress);
		
	},
	//选择的地址
	[CHOOSE_ADDRESS](state, {
		address,
		index
	}) {
		state.choosedAddress=null;
		state.addressIndex=-1;
		state.choosedAddress = address;
		state.addressIndex = index;
	},
	
	//保存下单需要验证的返回值
	[NEED_VALIDATION](state, needValidation) {
		state.needValidation = needValidation;
	},
	//保存下单后购物id 和 sig
	[SAVE_CART_ID_SIG](state, {
		cart_id,
		sig
	}) {
		state.cart_id = cart_id;
		state.sig = sig;
	},
	//保存下单参数，用户验证页面调用
	[SAVE_ORDER_PARAM](state, orderParam) {
		state.orderParam = orderParam;
	},
	//修改下单参数
	[CHANGE_ORDER_PARAM](state, newParam) {
		state.orderParam = Object.assign({}, state.orderParam, newParam);
	},
	//下单成功，保存订单返回信息
	[ORDER_SUCCESS](state, order) {
		state.cartPrice = null;
		state.orderMessage = order;
	},
	//进入订单详情页前保存该订单信息
	[SAVE_ORDER](state, orderDetail) {
		state.orderDetail = orderDetail;
	},
	//退出登录
	[OUT_LOGIN](state) {
		state.userInfo = null;
		//removeStore('loginer')
	},
	//保存图片
	[SAVE_AVANDER](state, imgPath) {
		state.imgPath = imgPath;
	},
	//删除地址列表
	[SAVE_ADDRESS](state, newAdress) {
		state.removeAddress = newAdress
	},
	//添加地址name
	[SAVE_ADDDETAIL](state, addAddress){
		state.addAddress=addAddress;
	},
	//保存所选问题标题和详情
	[SAVE_QUESTION](state, question) {
		state.question = {...question};
	},
	//增加地址
	[ADD_ADDRESS](state, obj) {
		state.removeAddress = [obj, ...state.removeAddress];
	},
	//会员卡价格纪录
	[BUY_CART](state, price) {
		state.cartPrice = price;
	},
	[SET_CONTRACT](state,item){
		state.contract=item;
	},
	[SAVE_EXTEND](state,item){
		state.userInfo.value.binding.ar_value=item.Ar;
		state.userInfo.value.binding.pt=item.Point;
	},
	[SAVE_LRPR](state,item){
		state.userInfo.value.binding.register.lrp_reminder=item==0?null:item;
	},
	[SAVE_PAYRECORD](state,item){
		state.payrecord=item;
	},
	[SET_ORDERNN](state,item){
		state.orderno=item;
	},
	[PAY_STATE](state,item){
		state.payState=item
	},
	[EDIT_USERINFO_QRCODE](state,qr_code){
		state.userInfo.value.binding.qr_code=qr_code;
	},
	[SET_PROMTE](state,item){
		state.promote=item;
	},
	[CLEAR_DATA](state){
		state.forCustomer=null;
		state.choosedAddress=null 
		state.newpromoCode={};
	},
	[INIT_NEWPROMOCODE](state,data){
		var carinfo= data.cart.value||{}
		var code=carinfo.pc||{};
		var codeList=carinfo.codeList||{}
		if(!data.status){
			for (var key in codeList) {
				if(code[key]){
					var model=JSON.parse(codeList[key]||{})
					model.forEach((item,index)=>{
						if(code[key][item.code]){
							code[key][item.code].num=item.num
						}
					})
				}
			}
		}
		else{
			code=state.newpromoCode||{};
	
		}
		state.newpromoCode=code;
	},
	[SET_NEWPROMOCODE](state,{
		item,
		sku
	}){
		var list=state.newpromoCode||{};
		list[sku]=item;
		state.newpromoCode={...list}
	},
	[SET_NEWPROMOCODEALL](state,item){
		var list=state.newpromoCode||{};
		list=item;
		state.newpromoCode=list
	},
	[REDUCE_NEWPROMOCODE](state,item){
		var list=state.newpromoCode||{};
		delete list[item];
		state.newpromoCode={...list}
	},
	[SET_ORIGINA](state,item){
		state.isOrigina=item;
	},
	[SET_FORCUSTOMER](state,item){
		// if(item){  //移除购物车 兑换过商品
		// 	// let cart = (state.cartInfo||{});
		// 	// let val = cart.value = (cart.value || {}); 
		// 	// let list = val.detail = (val.detail || {});
			
		// 	// Object.values(list).forEach(categoryItem => {
		// 	// 	Object.values(categoryItem).forEach(itemValue=> {
		// 	// 		Object.values(itemValue).forEach(item => {
		// 	// 				if(item.point>0)
		// 	// 				{	
		// 	// 					item.amount = item.num * item.price;
		// 	// 					item.point=0;								
		// 	// 				}
		// 	// 				let ppt = item.pt > 0 ? item.point / item.pt : 0;
		// 	// 				val.num += item.num						//购买产品总数（包括兑换的数量）
		// 	// 				val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
		// 	// 				val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
		// 	// 				val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	 		
		// 	// 				val.total_change_point += item.point;		//订单兑换PT总和                		  		
		// 	// 				val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
		// 	// 		})
		// 	// 	})
		// 	// });
		// 	// state.cartInfo = {...cart};
		// 	// console.log(state.cartInfo)
		// }
		state.forCustomer=item;
	},
	[SET_CHARITABLE](state,item){
		if(!item.result){
			state.charitable.result=false;
			state.charitable.list=[];
		}
		else{
			state.charitable.list=item.list;
			state.charitable.result=true;
		}
	},
	[SET_ORDERTYPE](state,item){
		state.orderType=item;
	},
	[SET_ORDERSTATUS](state,item){
		state.orderStatus=item;
	},
	[SET_BIRTHDAYLIMT](state,item){
		state.birthdayLimt=item;
	},
	[REDUCE_PAYLOAD](state,item){
		var list=state.payLoad||{};
		delete list[item];
		state.payLoad={...list}
	},
	[SET_PAYLOAD](state,item){
		var list=state.payLoad||{};
		list[item.orderNo]=item;
		state.payLoad={...list}
	},
	[REDUCEALL_ORDERINFO](state){
		state.orderType=0;

		var cart=state.cartInfo||{};
		var info=cart.value||{};
		var detail=info.detail||[];

		state.cartInfo = cart;

		state.forCustomer=null;
		state.choosedAddress=null 
		state.newpromoCode={};

		state.charitable.result=false;
		state.charitable.list=[];

	},
	[SET_PRODUCTLIMT](state,item){
		state.productLimt=item;
	},
	[SET_SELECTMERGE](state,item){
		state.virtual_flag=item;
	},
	//设置购物车的汇总信息
	[SET_CART_TOTALRPT](state, {
		delivery_fee,
		service_fee,
		ar_value
		//,pay_fee
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 			
		let list = val.detail = (val.detail || []);
		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
		
		list.forEach((item)=>{
			// if(item.is_lrpt_product>0){
			// 	item.num=0;
			// } 
			let ppt = item.pt > 0 ? item.point / item.pt : 0;
			val.num += item.num;							//购买产品总数（包括兑换的数量）
			val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
			val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
			val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	    		
			val.total_change_point += item.point;		//订单兑换PT总和                		  		
			val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
		})
		
       
	    val.delivery_fee = delivery_fee;			//快递费
	    val.service_fee = service_fee;				//服务费
	    val.ar_value = ar_value;					//AR支付金额
	    	
	    var tt = val.total_product_amount + val.delivery_fee + val.service_fee - val.ar_value;
	    val.pay_fee = tt;							//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
    	
		state.cartInfo = cart
	
	},
	[LOAD_CARTCHECK](state){
		var cartCheck=state.cartCheck||{}
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 			
		let list = val.detail = (val.detail || []);
		if(list[0]){
			list.forEach((item,index)=>{
				if(typeof(cartCheck[item.sku])=='undefined'){
					cartCheck[item.sku]=true
				}
			})
		}
		state.cartCheck=cartCheck
	},
	[SET_CARTCHECKALL](state,result){
		var cartCheck=state.cartCheck||{}
		for(var item in cartCheck){
			cartCheck[item]=result
		}
		state.cartCheck={};
		state.cartCheck=cartCheck;
	},
	[SET_CARTCHECK](state,item){
		var cartCheck=state.cartCheck||{}
		cartCheck[item]=cartCheck[item]?true:false
		state.cartCheck={};
		state.cartCheck=cartCheck;
	},
	[SET_BALANCERECORD](state){
		state.balanceRecord={};
	},
	[REDUCEALL_SELCART](state){
		var cartCheck=state.cartCheck||{}
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 			
		let list = val.detail = (val.detail || []);
		var newList=[]
		list.forEach((item,index)=>{
			if(!cartCheck[item.sku]){
				newList.push(item)
			}
		})
		state.choosedAddress=null;
		state.newpromoCode={};
		state.balanceRecord={};
		val.detail=newList;
		state.cartInfo=cart;
	},
	[TRIGGER_MERGE](state,value) {
		if (value === '0') {
			state.checkedMerge = false
		} else {
			state.checkedMerge = !state.checkedMerge
		}
		
	},
	[SET_PTBALANCE](state,value) {
		state.ptBalance = value
	},
	[SET_COMBINEPROMOTEPRODUCT](state,value) {
		if (value) {
			state.combinePromote = value
		} else {
			state.combinePromote = {}
		}
		
	},
	[SET_PRODUCTMENUTREE](state,value) {
		state.productMenuTree = value
	},
}
